(function ($, Drupal) {
  if (Drupal.AjaxCommands) {
    const originalViewsScrollTop = Drupal.AjaxCommands.prototype.scrollTop;

    Drupal.AjaxCommands.prototype.scrollTop = function (
      ajax,
      response,
      status
    ) {
      if (
        ajax.submit.view_display_id !== undefined &&
        ajax.submit.view_name !== undefined &&
        ajax.submit.view_display_id === "kitchen_sink" &&
        ajax.submit.view_name === "latest_content"
      ) {
        return;
      }
      originalViewsScrollTop.call(this, ajax, response, status);
    };
  }
})(jQuery, Drupal);
